import { LoadingButton } from '@mui/lab';
import { Stack, TextField } from '@mui/material';
import React from 'react';
import { useForm } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { commonMessages } from 'utils/commonMessages';
import { NewProduct } from './CreateProductStep';

interface CreateProductStepActiveProps {
  completeStep(newProduct: NewProduct): void,
}

interface CreateProductStepActiveFormData {
  productName: string,
  sku: string
}

export const CreateProductStepActive: React.FC<CreateProductStepActiveProps> = ({ completeStep }) => {
  const { formatMessage } = useIntl();
  const { handleSubmit, register, formState: { errors, isSubmitting } } = useForm<CreateProductStepActiveFormData>();

  const onSubmit = (formData: CreateProductStepActiveFormData) => {
    completeStep({
      name: formData.productName,
      sku: formData.sku
    });
  };

  return (
    <Stack marginLeft={7} marginTop={5}>
      <Stack gap={3} >
        <TextField
          {...register('productName', { required: formatMessage(commonMessages.fieldIsRequired) })}
          autoComplete='productName'
          variant="outlined"
          fullWidth
          error={Boolean(errors.productName)}
          helperText={errors.productName?.message}
          label={formatMessage(commonMessages.productName)}
        />
        <TextField
          {...register('sku', { required: formatMessage(commonMessages.fieldIsRequired) })}
          autoComplete='sku'
          variant="outlined"
          fullWidth
          error={Boolean(errors.sku)}
          helperText={errors.sku?.message}
          label={formatMessage(commonMessages.productSku)}
        />

        <Stack direction='row-reverse'>
          <LoadingButton variant="contained" color='primary' loading={isSubmitting} onClick={handleSubmit(onSubmit)}>
            {formatMessage(commonMessages.continue)}
          </LoadingButton>
        </Stack>
      </Stack>
    </Stack>
  );
};